/*
 * @FilePath     : /mpx-es-ui/src/components/toast/functional.js
 * @Author       : LiYang
 * @Date         : 2021-10-11 11:31:57
 * @LastEditTime : 2021-12-28 18:19:07
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

import { isObject, isDef } from '@didi/es-mpx-shared'

let queue = [];
const conver = option =>  option = isObject(option) ? option: { message: option } ;

const Toast = (option) => {
  option = conver(option);
  const pages = getCurrentPages();
  const context = pages[pages.length - 1];
  const toast = context.selectComponent((option.selector || '#es-toast'));
  
  if (isDef(toast)) {
    toast.setOption({
      show: true,
      ...option
    });

    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => {
      toast.clear();
      toast.timer = null;
    }, option.duration || 2000);
    
    !queue.includes(toast) && queue.push(toast);
  }
}

const createMethod = name => option => Toast({
  ...conver(option),
  name,
})

Toast.loading = createMethod('loading')

Toast.success = createMethod('right')

Toast.fail = createMethod('wrong');

Toast.clear = () => {
  queue.forEach(toast => toast.clear());
  queue = [];
}
export default Toast;